import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/utamed-logo-blanco-horizontal.svg")